import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IDetailedReportSearch } from '../../reports/models/detailed-report-search.model';
import { IDetailedReportGrid } from '../../reports/models/detailed-report-grid.model';
import { HttpHeaders } from '@angular/common/http';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { PagedResult } from '../../shared/models/pagedResult.model';
import { LoggedInUserService } from '../common/logged-in-user.service';
import { SearchRecurringBenefitModel } from '../../reports/models/search-recurring-benefit.model';
import { RecurringBenefitsModel } from '../../reports/models/recurring-benefits-model';
import { BaseHttpService } from '../common/base.http.service';
import { reportConst } from '../../reports/report.constants';
import { ILineType } from '../../administration/models/line-type.model';
import { SearchSummaryReportModel } from '../../reports/models/search-report-summary.model';
import { SummaryReportModel } from '../../reports/models/summary-report.model';
import { SearchSalaryAccountPaymentModel } from '../../reports/models/search-salary-account-payment.model';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  baseHttpService = inject(BaseHttpService);
  loggedInUserService = inject(LoggedInUserService);

  search(params: SearchParameters<IDetailedReportSearch>) : Observable<PagedResult<IDetailedReportGrid[]>> {      
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.loggedInUserService.currentUser$.subscribe(data => {
      params.userEmail = data.userEmail;
    })
    return this.baseHttpService.post<PagedResult<IDetailedReportGrid[]>>(reportConst.reports, params, { headers: headers });
  }

  searchRecurringBenefits(params: SearchParameters<SearchRecurringBenefitModel>) : Observable<PagedResult<RecurringBenefitsModel[]>> {      
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.loggedInUserService.currentUser$.subscribe(data => {
      params.userEmail = data.userEmail;
    })
    return this.baseHttpService.post<PagedResult<RecurringBenefitsModel[]>>(reportConst.recurringBenefits, params, { headers: headers });
  }

  searchSummaryReport(params: SearchParameters<SearchSummaryReportModel>) : Observable<PagedResult<SummaryReportModel[]>> {      
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.loggedInUserService.currentUser$.subscribe(data => {
      params.userEmail = data.userEmail;
    })
    return this.baseHttpService.post<PagedResult<SummaryReportModel[]>>(reportConst.summaryReport, params, { headers: headers });
  }

  searchSalaryAccountPayments(params: SearchParameters<SearchSalaryAccountPaymentModel>) : Observable<PagedResult<SearchSalaryAccountPaymentModel[]>> {      
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.loggedInUserService.currentUser$.subscribe(data => {
      params.userEmail = data.userEmail;
    })
    return this.baseHttpService.post<PagedResult<SearchSalaryAccountPaymentModel[]>>(reportConst.salaryAccountPayment, params, { headers: headers });
  }

  getRecurringLineTypes() : Observable<ILineType[]> {      
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });    
    return this.baseHttpService.get<ILineType[]>(reportConst.recurringLineTypes, { headers: headers });
  }
}
